import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid } from '../cacheUtils';

export const fetchSupport = createAsyncThunk(
  'support/fetchSupport',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().support;
    if (isCacheValid(state.lastFetched)) {
      return { data: state.data, cached: true };
    }
    try {
      const response = await Axios.get('/api/support');
      return { data: response.data.data, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch support');
    }
  }
);

export const fetchSupportMetrics = createAsyncThunk(
  'support/fetchMetrics',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().support;
    if (isCacheValid(state.metricsLastFetched)) {
      return { data: state.metrics, cached: true };
    }
    try {
      const response = await Axios.get('/api/support/metrics');
      return { data: response.data.data, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch support metrics');
    }
  }
);

const supportSlice = createSlice({
  name: 'support',
  initialState: {
    data: null,
    metrics: null,
    loading: false,
    metricsLoading: false,
    error: null,
    lastFetched: null,
    metricsLastFetched: null,
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = null;
      state.metricsLastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupport.pending, (state) => {
        if (!state.data) state.loading = true;
      })
      .addCase(fetchSupport.fulfilled, (state, action) => {
        if (!action.payload.cached) {
          state.data = action.payload.data;
          state.lastFetched = Date.now();
        }
        state.loading = false;
      })
      .addCase(fetchSupport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSupportMetrics.pending, (state) => {
        if (!state.metrics) state.metricsLoading = true;
      })
      .addCase(fetchSupportMetrics.fulfilled, (state, action) => {
        if (!action.payload.cached) {
          state.metrics = action.payload.data;
          state.metricsLastFetched = Date.now();
        }
        state.metricsLoading = false;
      })
      .addCase(fetchSupportMetrics.rejected, (state, action) => {
        state.metricsLoading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidateSupportCache } = supportSlice.actions;
export default supportSlice.reducer;